import { Injectable, Renderer2 } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class PlayingVideoService {
    initPlayer(container: HTMLElement, renderer: Renderer2, videoSrc: string, previewSrc: string): void {
        // Contenedor del thumbnail
        const wrapper = renderer.createElement('div');
        renderer.setStyle(wrapper, 'position', 'relative');
        renderer.setStyle(wrapper, 'width', '150px');
        renderer.setStyle(wrapper, 'cursor', 'pointer');
        renderer.setStyle(wrapper, 'border-radius', '12px');
        renderer.setStyle(wrapper, 'overflow', 'hidden');
        renderer.setStyle(wrapper, 'box-shadow', '0 2px 10px rgba(0,0,0,0.15)');

        // Imagen local (no se bloquea)
        const img = renderer.createElement('img');
        renderer.setAttribute(img, 'src', previewSrc);
        renderer.setStyle(img, 'width', '100%');
        renderer.setStyle(img, 'display', 'block');
        renderer.setStyle(img, 'object-fit', 'cover');

        // Overlay de Play (inicialmente oculto)
        const play = renderer.createElement('div');
        renderer.setStyle(play, 'position', 'absolute');
        renderer.setStyle(play, 'top', '50%');
        renderer.setStyle(play, 'left', '50%');
        renderer.setStyle(play, 'transform', 'translate(-50%, -50%)');
        renderer.setStyle(play, 'background', 'rgba(0, 0, 0, 0.6)');
        renderer.setStyle(play, 'border-radius', '50%');
        renderer.setStyle(play, 'width', '40px');
        renderer.setStyle(play, 'height', '40px');
        renderer.setStyle(play, 'display', 'none'); // Inicialmente oculto
        renderer.setStyle(play, 'justify-content', 'center');
        renderer.setStyle(play, 'align-items', 'center');
        renderer.setStyle(play, 'cursor', 'pointer');

        play.innerHTML = `
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
            <path d="M8 5v14l11-7z"></path>
        </svg>
    `;

        // Mostrar el icono de play al hacer hover
        renderer.listen(wrapper, 'mouseenter', () => {
            renderer.setStyle(play, 'display', 'flex'); // Mostrar el icono
        });

        // Ocultar el icono de play al quitar el hover
        renderer.listen(wrapper, 'mouseleave', () => {
            renderer.setStyle(play, 'display', 'none'); // Ocultar el icono
        });

        // Acción al hacer clic
        wrapper.addEventListener('click', () => {
            window.open(videoSrc, '_blank');
        });

        // Append de elementos
        renderer.appendChild(wrapper, img);
        renderer.appendChild(wrapper, play);
        renderer.appendChild(container, wrapper);
    }
}
